const input = {
    username: 'ユーザー名',
    password: 'パスワード',
    email: 'メールアドレス',
    phone_number: '電話番号',
    confirm_password: 'パスワード確認',
    search_region_code: '地域コード検索',
    backup_code: 'バックアップコード',
};
export default Object.freeze(input);
